
(function () {
  'use strict';

  if (window.__aboutUsAnimationsInit) return;
  window.__aboutUsAnimationsInit = true;

  var prefersReduced =
    window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init() {
    if (prefersReduced) return; 


    var revealTargets = document.querySelectorAll(
      '[data-fade-up], [data-reveal-item], [data-slide-in]'
    );

    if ('IntersectionObserver' in window && revealTargets.length) {
      var revealObserver = new IntersectionObserver(
        function (entries, observer) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target); // fire once
          });
        },
        { threshold: 0.15, rootMargin: '0px 0px -10% 0px' }
      );
      revealTargets.forEach(function (el) {
        revealObserver.observe(el);
      });
    } else {
      // No IntersectionObserver support: show everything.
      revealTargets.forEach(function (el) {
        el.classList.add('is-visible');
      });
    }

    var fillTargets = Array.prototype.slice.call(
      document.querySelectorAll('[data-scroll-fill]')
    );

    if (fillTargets.length) {
      fillTargets.forEach(function (el) {
        if (el.querySelector('.sf-overlay')) return; 
        var overlay = document.createElement('span');
        overlay.className = 'sf-overlay';
        overlay.setAttribute('aria-hidden', 'true');
        overlay.innerHTML = el.innerHTML;
        el.appendChild(overlay);
      });

      var ticking = false;

      var updateFills = function () {
        ticking = false;
        var vh = window.innerHeight || document.documentElement.clientHeight;
        fillTargets.forEach(function (el) {
          var rect = el.getBoundingClientRect();
          var start = vh * 0.85;
          var end = vh * 0.35;
          var progress = (start - rect.top) / (start - end);
          if (progress < 0) progress = 0;
          if (progress > 1) progress = 1;
          el.style.setProperty('--fill', (progress * 100).toFixed(2) + '%');
        });
      };

      var onScroll = function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(updateFills);
      };

      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });
      updateFills();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
